export default {
  MyContacts: 'الطلب الفعال|طلباتي الفعالة',
  MyContacts_no_body: 'طلب فعال',
};
